import { apiGet } from '../_common';

export default {
  search(query) {
    return apiGet('/magenta/stock/entry/summary', query).then(result => result.response);
  },
};
